// client/src/pages/Game/Battlefield/components/DeckSelector.jsx

import React from 'react';
import Button from '../../../../components/ui/Button';

/**
 * Composant pour sélectionner un deck au début de la partie
 * @param {Object} props Les propriétés du composant
 * @param {String} props.gameId ID de la partie
 * @param {String} props.selectedDeckId ID du deck sélectionné
 * @param {Function} props.onDeckSelect Fonction appelée lors de la sélection d'un deck
 * @param {Function} props.onStartGame Fonction appelée pour démarrer la partie
 * @param {Function} props.onCancel Fonction appelée pour annuler
 * @param {Boolean} props.isStartingGame Si le démarrage de la partie est en cours
 * @param {String} props.error Message d'erreur éventuel
 * @returns {JSX.Element} Le composant DeckSelector
 */
const DeckSelector = ({
  gameId,
  selectedDeckId,
  onDeckSelect,
  onStartGame,
  onCancel,
  isStartingGame,
  error
}) => {
  return (
    <div className="battlefield-setup">
      <h2>{gameId === 'ai' ? "Nouvelle partie contre l'IA" : "Rejoindre une partie"}</h2>
      <div className="deck-options">
        <div 
          className={`deck-option ${selectedDeckId === 'starter_fire' ? 'selected' : ''}`}
          onClick={() => onDeckSelect('starter_fire')}
        >
          <div className="deck-preview">
            <h3>Deck de Feu</h3>
            <div className="deck-element">Feu</div>
          </div>
          <p>Deck de démarrage offensif.</p>
        </div>
        
        <div 
          className={`deck-option ${selectedDeckId === 'starter_water' ? 'selected' : ''}`}
          onClick={() => onDeckSelect('starter_water')}
        >
          <div className="deck-preview">
            <h3>Deck d'Eau</h3>
            <div className="deck-element">Eau</div>
          </div>
          <p>Deck de démarrage défensif.</p>
        </div>
      </div>
      <div className="deck-setup-actions">
        <Button
          type="outline"
          onClick={onCancel}
        >
          Annuler
        </Button>
        <Button
          type="primary"
          onClick={onStartGame}
          disabled={isStartingGame}
          className="start-game-button"
        >
          {isStartingGame ? 'Chargement...' : gameId === 'ai' ? 'Commencer la partie' : 'Rejoindre la partie'}
        </Button>
      </div>
      {error && (
        <div className="error-message">
          <p>{error}</p>
        </div>
      )}
    </div>
  );
};

export default DeckSelector;